import { Exclude, Expose } from "class-transformer";

@Exclude()
class UpdateBrandDealerBindDto {
    @Expose()
    readonly dealer_id: number;

    @Expose()
    readonly brand_id: number;

    @Expose()
    readonly price: number;
}

export default UpdateBrandDealerBindDto;
